import React from "react";
import logoData from "../../assets/img/services/PeerToPeer/polygon.png";
import Peer from "../../assets/img/services/PeerToPeer/peerimg.png";

function PeerToPeer() {
  return (
    <div className="">
      <div>
        <div className="flex flex-col h-full items-center w-full justify-center">
          <div className="flex flex-col lg:flex-row lg:w-[80%] m-auto text-left justify-center w-full">
            <div className="w-full lg:w-1/2">
              <img
                src={Peer}
                alt=""
                className="m-auto mb-5 pr-12 pl-8 w-[80%]"
              />
            </div>
            <div className="flex items-center justify-center md:w-[80%]">
              <div className="block">
                <div className=" font-bold text-[18px] lg:text-[24px] text-white md:text-left uppercase mb-5 sm:pl-8">
                  PEER TO PEER COMPUTING
                </div>
                <div className="sm:pl-8">
                  <p className=" text-white  md:text-left break-words lg:w-[90%] mb-5 text-xs md:text-lg">
                    A peer-to-peer network (P2P) is an information technology
                    (IT) infrastructure allowing two or more computer systems to
                    connect and share resources without requiring a separate
                    server or server software. Workplaces may set up a P2P
                    network by physically connecting computers into a linked
                    system or creating a virtual network. You can also set up
                    computers to be the clients and servers of their network.
                  </p>
                  <div
                    className="w-[85%] flex flex-col rounded-[13px] bgList"
                    style={{ background: "rgba(12,16,69,0.38)" }}
                  >
                    <div
                      className="rounded-[13px] lg:border lg:border-solid lg:border-white  py-4 sm:scale-[0.8] scale-[0.9]"
                      style={{ background: "rgba(12,16,69,0.38)" }}
                    >
                      <div className="flex flex-col gap-3">
                        <div className="lg:mx-10 flex justify-start">
                          <ul className="flex flex-row justify-between lg:text-[18px] text-[11px] lg:pl-0 lg:gap-5 lg:w-full lg:mx-[5%] w-full gap-1">
                            <div className="w-1/2">
                              <div className="flex flex-row gap-2">
                                <img src={logoData} alt="polygon" />
                                <div className="flex items-center">
                                  Easy file sharing
                                </div>
                              </div>
                            </div>
                            <div className="w-1/2">
                              <div className="flex flex-row gap-2">
                                <img src={logoData} alt="polygon" />
                                <div className="flex items-center">
                                  Adaptability
                                </div>
                              </div>
                            </div>
                          </ul>
                        </div>
                        <div className="lg:mx-10 flex justify-start">
                          <ul className="flex flex-row justify-between lg:text-[18px] text-[11px] lg:pl-0 lg:gap-5 lg:w-full lg:mx-[5%] w-full gap-1">
                            <div className="w-1/2">
                              <div className="flex flex-row gap-2">
                                <img src={logoData} alt="polygon" />
                                <div className="flex items-center">
                                  Reduced Cost
                                </div>
                              </div>
                            </div>
                            <div className="w-1/2">
                              <div className="flex flex-row gap-2">
                                <img src={logoData} alt="polygon" />
                                <div className="flex items-center">
                                  Reliability
                                </div>
                              </div>
                            </div>
                          </ul>
                        </div>
                        <div className="lg:mx-10 flex justify-start">
                          <ul className="flex flex-row justify-between lg:text-[18px] text-[11px] lg:pl-0 lg:gap-5 lg:w-full lg:mx-[5%] w-full gap-1">
                            <div className="w-1/2">
                              <div className="flex flex-row gap-2">
                                <img src={logoData} alt="polygon" />
                                <div className="flex items-center">
                                  Adaptability
                                </div>
                              </div>
                            </div>
                            <div className="w-1/2">
                              <div className="flex flex-row gap-2">
                                <img src={logoData} alt="polygon" />
                                <div className="flex items-center">
                                  High Performance
                                </div>
                              </div>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="fixed right-0 -bottom-[22%] sm:-bottom-[6%] font-bold text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] sm:scale-[0.7] sm:-left-36 h2Mobile md:block hidden">
          EFFICIENCY
        </h2>
      </div>
    </div>
  );
}

export default PeerToPeer;
